const TableStatic = () => {
  return (
    <div className="bg-white rounded-lg p-10 w-100">
      <table className="table-auto overflow-x-scroll table-100">
        <thead className="bg-gray-50 border-b-2 border-gray-200">
          <tr>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Total</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Region</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Grupo</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Inmueble</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Tipo de servicio</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Tipo de dispositivo</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Total de dispositivos</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">Numero de nodos</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">IP</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">PS</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">TMP</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">CPU</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">MEM</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">PP</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">MOS</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">JIT</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">LAT</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">RPV</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">USO</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">AB</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">REN</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">X1</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">X2</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">X3</th>
            <th className="p-3 text-sm font-semibold tracking-wide text-left">X4</th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr><tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
          <tr className="bg-white whitespace-nowrap">
            <td className="px-6 py-4 text-sm">1000</td>
            <td className="px-6 py-4 text-sm">Norte</td>
            <td className="px-6 py-4 text-sm">Regional</td>
            <td className="px-6 py-4 text-sm">Sobre mesa</td>
            <td className="px-6 py-4 text-sm">4G</td>
            <td className="px-6 py-4 text-sm">firewall</td>
            <td className="px-6 py-4 text-sm">103</td>
            <td className="px-6 py-4 text-sm">1005</td>
            <td className="px-6 py-4 text-sm">225.225.124</td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="green-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="yellow-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
            <td>
              {' '}
              <section className="red-primary" />{' '}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableStatic;
